<template>
<div id="app">
  <b-navbar id="navigationBar" toggleable="lg" type="dark" fixed="top">
    <b-navbar-brand href="#"> <img class="logo" src="./assets/logos/cartodialect_logo.png"/> CartoDialect {{currentVersion}}</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
    <b-navbar-nav>
      <b-nav-item>
        <router-link class="navBarItem" tag="a" to="/">Accueil</router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link class="navBarItem" tag="a" to="/recherche">Recherche</router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link class="navBarItem" tag="a" to="/visualiseur">Visualiseur</router-link>
      </b-nav-item>
      <b-nav-item href="https://eclats.gricad-pages.univ-grenoble-alpes.fr/cartodialect_guide_utilisateur/" target="blank">À propos</b-nav-item>
    </b-navbar-nav>
    <span class="spacer"></span>

    <div id="loginButtons">
      <b-button id="loginButtons" variant="transparent" v-if="!isAuthenticated" v-b-modal.modal-1 data-backdrop="false">Connexion</b-button>
      <div v-if="isAuthenticated"> 
      <span id="username">  --- {{currentUser.username}} --- </span>
        <b-button id="loginButtons" variant="transparent" @click="logOut()">Deconnexion</b-button>
      </div>
    </div>
  </b-collapse>
    <login-page></login-page>
    <!-------------------- Fenêtre modale pour l'édition de transcription phonétique --------------------------->
    <modal v-if="currentInventoryEntry" name="dialog" @before-open="beforeOpen"> 
      <div class="container">
      <!--
        <div v-if="modalCirclePhoneticTranscriptions.length > 1">
          <p>PE n° {{ modalCircle.node().id }} a déjà plusieurs transcriptions phonétiques, 
            choisissez la TP sur laquelle l'action sera effectuée </p>
          <b-form-group label-for="phoneticTranscriptionSelect" description="choisir">
            <b-form-select :options="modalCirclePhoneticTranscriptions" size="lg" v-model="selectedPhoneticTranscription"></b-form-select>
          </b-form-group>
        </div>
      -->
        <div v-if="modalCirclePhoneticTranscriptions.length > 1">
          <p>PE n° {{ modalCircle.node().id }}</p> 
          <p>transcriptions phonétiques : 
            <span v-for="(phoneticTranscription, index) in modalCirclePhoneticTranscriptions" :key="`phoneticTranscription-${index}`">
                {{ phoneticTranscription }} 
                {{ index < modalCirclePhoneticTranscriptions.length -1 ? ', ' : ''}}
            </span>
          </p>
        </div>
        <div v-if="modalCirclePhoneticTranscriptions.length == 1">
          <p>PE n° {{ modalCircle.node().id }}</p>
          <p>transcription phonétique: {{selectedPhoneticTranscription}} </p>
        </div>
        <hr>
        <p> Choisissez l'action à effectuer: </p>
        <div>
        <b-button @click="updateCircleList(true)"> Remplacer </b-button>
        <b-button @click="updateCircleList(false)"> Ajouter </b-button>
        <b-button @click="closeModal()"> Annuler </b-button>
        </div>
         <div v-if="modalCirclePhoneticTranscriptions.length > 1">
           <br>
            <b-form-text>
                Choisissez la transcription à remplacer 
            </b-form-text>
            <b-form-select :options="modalCirclePhoneticTranscriptions" size="lg" v-model="selectedPhoneticTranscription"></b-form-select>
          
        </div>
        </div>
    </modal>  
  <!---------------------------------------------------------------------------------------------------------->

  </b-navbar>
  <router-view v-if="hasLoadedData"></router-view>
</div>
</template>

<script>
import LoginPage from './components/commons/LoginPage'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'App',
  components: { LoginPage },
  data(){ 
    return {
      modalCirclePhoneticTranscriptions: [],
      selectedPhoneticTranscription: null
    }
  },
  watch: {
    showModal(){
      if(this.showModal) {
        this.$modal.show('dialog')
      } else { 
        this.$modal.hide('dialog')
      }
    }
  },
  created() {
    // Récupération des cartes de l'ALF à la création du composant racine
    this.$store.dispatch('getAllMaps')
    this.$store.dispatch('getAllSurveyPoints')
  },
  computed: {
    ...mapGetters({
      currentVersion: 'getCurrentVersion',
      currentUser: 'getCurrentUser',
      currentInventoryEntry: 'getCurrentInventoryEntry',
      isAuthenticated: 'getIsAuthenticated',
      showModal: 'getShowModal',
      modalCircle: 'getModalCircle'
    }),
    // Affiche le composant si les données ont été complètement chargées
    hasLoadedData: function() {
      return this.$store.state.hasLoadedData
    }
  },
  methods: {
    logOut: function() {
      this.$store.dispatch('logOut')
    },
    // Avant d'ouvrir la boîte de dialogue, récupération des TP du PE cliqué
    beforeOpen() {
      this.modalCirclePhoneticTranscriptions = []
      return axios.get(this.$store.getters.getUrlServeur + '/findAllResponses', {
        params: {
          inventoryEntry: this.modalCircle.node().attributes.inventoryEntryId.value
        }
    }).then(response => { 
      for(let i = 0; i < response.data.length; i++) {
          this.modalCirclePhoneticTranscriptions.push(response.data[i].rousselotPhoneticForm)
      }
      this.selectedPhoneticTranscription = this.modalCirclePhoneticTranscriptions[0]
    })
    },
    // Génère les bouttons de la fenêtre modale permettant de choisir entre les différentes actions
    // possible à la propagation d'une transcription phonétique
    updateCircleList: function(replace) {
      this.modalCircle.node().attributes.rousselotPhoneticForm.value = this.selectedPhoneticTranscription
      this.$store.dispatch('addShiftClickedCircle', { d3Circle: this.modalCircle, replace: replace }) 
      this.$store.dispatch('resetModal') 
    },
    closeModal: function() {
      this.$modal.hide('dialog')
      this.$store.dispatch('resetModal') 
    }
  }
}
</script>

<style>
.modal-backdrop {
  background-color: transparent !important;
}

.logo {
width: 30px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#navigationBar {
  background-color: #800000;
}

.navBarItem {
  color: #b38080;
  outline: none;
  text-decoration: none;
  padding: 2px 1px 0;
}

a.navBarItem:hover {
  color: white;
  text-decoration: none;
}

.navBarItem a:hover {
  color: white;
}

.spacer {
  flex: 1 1 auto;
}

#loginButtons {
color: white;
}

.leftAlign {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue